// extracted by mini-css-extract-plugin
module.exports = {"Category-section-button__child":"server-category-section-button_Category-section-button__child__cNzi9"};